import { createSlice } from "@reduxjs/toolkit";
import { getUsers, addUser, editUser } from "./thunk";
import { toast } from "react-toastify";
export const initialState = {
  users: [],
  error: null,
  addSuccess: null,
  editSuccess: null,
  loading: false,
  pagination: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
  },
};

const UsersSlice = createSlice({
  name: "UsersSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state, action) => {
      state.loading = true;     
      state.error = {};
      state.addSuccess = null;
      state.editSuccess = null;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message.indexOf("http") === -1) {
        state.users = action.payload.data;
        if (action.payload.pagination) {
          state.pagination = action.payload.pagination;
        }
      } else window.open(action.payload.message, "_blank");
    });

    builder.addCase(getUsers.rejected, (state, action) => {
      // state.error = action.payload.error || null;
    });

    builder.addCase(addUser.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Adding User...", {
        position: "top-center",
        autoClose: false,
      });
      state.error = null;
      state.addSuccess = null;
      state.editSuccess = null;
    });

    builder.addCase(addUser.fulfilled, (state, action) => {
      if (action.payload.data === "User already exists") {
        state.error = action.payload.data;
        state.addSuccess = false;
      } else {
        state.users.push(action.payload.data);
        state.addSuccess = true;
      }
    });

    builder.addCase(addUser.rejected, (state, action) => {
      // state.error = action.error.message || null;
    });

    builder.addCase(editUser.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Updating User...", {
        position: "top-center",
        autoClose: false,
      });
      state.error = null;
      state.addSuccess = null;
      state.editSuccess = null;
    });

    builder.addCase(editUser.fulfilled, (state, action) => {
      state.users = state.users.map((user) =>
        user.user_id.toString() === action.payload.data.user_id.toString()
          ? { ...user, ...action.payload.data }
          : user
      );
      state.editSuccess = true;
    });

    builder.addCase(editUser.rejected, (state, action) => {
      // state.error = action.error.message || null;
    });

    /*
    builder.addCase(addSupplier.fulfilled, (state, action) => {
      state.suppliers.push(action.payload);
    });

    builder.addCase(addSupplier.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateSupplier.fulfilled, (state, action) => {
      state.suppliers = state.suppliers.map((supplier) =>
        supplier._id.toString() === action.payload.data._id.toString()
          ? { ...supplier, ...action.payload.data }
          : supplier
      );
    });

    builder.addCase(updateSupplier.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(deleteSupplier.fulfilled, (state, action) => {
      state.suppliers = (state.suppliers || []).filter(
        (supplier) =>
          supplier._id.toString() !== action.payload.supplier.toString()
      );
    });

    builder.addCase(deleteSupplier.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
    */
  },
});

export default UsersSlice.reducer;
